import { TypographyVariant } from "@mui/material"
import { IconSize } from "../../core/icons"

type TypographyVariantsType = {
  [key: string]: { [key: string]: TypographyVariant }
}

export const TYPOGRAPHY_VARIANTS_BY_SIZE: TypographyVariantsType = {
  title: {
    lg: "h3",
    sm: "h5"
  },
  text: {
    lg: "body1",
    sm: "body2"
  }
}

type IconSizesType = {
  [key: string]: IconSize
}

export const ICON_BY_SIZE: IconSizesType = {
  lg: "large",
  sm: "small"
}

export const STYLES_BY_SIZE = {
  container: {
    padding: {
      lg: 5,
      sm: 4
    }
  },
  defaultIcon: {
    width: {
      lg: "60px",
      sm: "36px"
    }
  },
  contentContainer: {
    gap: {
      lg: 4,
      sm: 2
    }
  },
  textContainer: {
    gap: {
      lg: 3,
      sm: 1
    }
  }
}
